import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select from 'react-select';
import config from 'config';
import { toast } from 'react-toastify';
import LibraryApiCall from 'LibraryApiCall';
import ReactHtmlParser from 'react-html-parser';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';

let multipleSelectOption = [];
let locationSubLocationData = [];
let categorySubCategoryData = [];
const baseNote =
    "If you select the parent resource, the action will apply to both the parent and all its copies. " +
    "If you select a copy, the action will apply only to that individual copy.";


class UpdateMultipleAction extends Component {

    constructor(props) {
        super(props)
        this.tableObject = {};
        this.myRef = React.createRef();
        this.state = {
            searchAccessionSeriesData: '',
            selectedValue: [],
            isMultiSelect: false,
            fieldNamePayload: '',
            fieldValuePayload: '',
            noteText: baseNote,
            updateLanguage: '',
            updatePublisher: '',
            updateCategory: '',
            updateLocation: '',
            updateDepartment: [],
            updateResourceType: '',
            fieldPlaceholder: '',
            updateResourceLoading: false
        }
    }

    componentDidMount() {
        let placeholderName = this.props.modalTitle.replace("Update ", "");
        this.setState({ fieldPlaceholder: this.props.modalTitle === "Mark as donated" ? "Donor" : placeholderName })

        if (this.props.modalTitle === "Update Resource Category") {
            this.setState({ isMultiSelect: true, noteText: baseNote })
        }
        if (this.props.modalTitle === "Update Invoice Number") {
            this.setState({ noteText: baseNote + " " + "Invoices/Bills should be added from the Accounting module to link to the resources in the Library module." })
        }
        if (this.props.modalTitle === "Mark as donated") {
            this.setState({ noteText: baseNote + " " + "If a resource is marked as donated then it will not have invoice details." })
        }
    }

    closeImportResourceModal = () => {
        this.setState({ selectedValue: [], fieldValuePayload: '', noteText: baseNote })
        this.props.onClose(); // Call parent function directly
    }

    UpdateMultipleResourceData = () => {
        if (this.props.modalTitle === "Update Accession Series") {
            this.apiCallForUpdateResourceData()
        } else if (this.props.modalTitle === "Update Resource Location") {
            this.setState({ fieldNamePayload: 'location', fieldValuePayload: this.state.selectedValue.value }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.props.modalTitle === "Update Resource Category") {
            let formattedValue = this.state.selectedValue?.length > 0 ? this.state.selectedValue.map(item => item.value) : [this.state.selectedValue.value];
            let jsonFormattedData = JSON.stringify(formattedValue);
            this.setState({ fieldNamePayload: 'resourceCategory', fieldValuePayload: jsonFormattedData }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.props.modalTitle === "Update Resource Type") {
            this.setState({ fieldNamePayload: 'resource_type', fieldValuePayload: this.state.selectedValue.value }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.props.modalTitle === "Update Invoice Number") {
            this.setState({ fieldNamePayload: 'invoiceno', fieldValuePayload: this.state.selectedValue.value }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.props.modalTitle === "Update Resource Status") {
            this.setState({ fieldNamePayload: 'resource_status', fieldValuePayload: this.state.selectedValue.value }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.props.modalTitle === "Update Resource Language") {
            this.setState({ fieldNamePayload: 'resource_lang', fieldValuePayload: this.state.selectedValue.value }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.props.modalTitle === "Mark as donated") {
            this.setState({ fieldNamePayload: 'donated', fieldValuePayload: this.state.selectedValue.value }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.props.modalTitle === "Update Resource Details") {
            this.apiCallForUpdateResourceDetailsData()
        }
    }

    stripHtml = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    }

    // API CALL METHOD TO UPDATE RESOURCE DETAILS
    apiCallForUpdateResourceDetailsData = async () => {
        this.setState({
            updateResourceLoading: true
        });

        let requestData = {
            'institute_id': this.props.resourceSearchIID, // config.institute_id,
            'unique_id_array': this.props.SelectedResourcesIdArray,
            'resource_language': this.state.updateLanguage ? this.state.updateLanguage.value : '',
            'publisher': this.state.updatePublisher ? JSON.stringify(this.state.updatePublisher.map(item => item.value)) : "",
            'category': this.state.updateCategory ? JSON.stringify(this.state.updateCategory.map(item => item.value)) : "",
            'location': this.state.updateLocation ? this.state.updateLocation.value : '',
            'department': this.state.updateDepartment ? JSON.stringify(this.state.updateDepartment.map(item => item.value)) : "",
            'type': this.state.updateResourceType ? this.state.updateResourceType.value : '',
            'facultyId': config.faculty_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'UpdateLibraryResourceDetails',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallForUpdateResourceDetailsData();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if (apiResult.status == "success") {
                    toast.success(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.setState({
                        updateResourceLoading: false
                    });
                    this.closeImportResourceModal()
                } else {
                    toast.warn(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.setState({
                        updateResourceLoading: false
                    });
                }
            } else {
                this.setState({
                    updateResourceLoading: false
                });
                toast.error('Something went wrong while updating resources data. Please try again later.', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    apiCallForUpdateResourceData = async () => {
        this.setState({
            updateResourceLoading: true
        });

        let requestData = {}
        let jsonResponse = {}

        if (this.props.modalTitle === "Update Accession Series") {
            requestData = {
                iid: this.props.resourceSearchIID, // config.institute_id,
                AccessionSeriesId: this.state.selectedValue.value,
                facultyId: config.faculty_id,
                SelectedResourcesIdArray: this.props.SelectedResourcesIdArray
            }

            jsonResponse = await LibraryApiCall.makeApiCall(
                "updateAccessionSeriesOfSelectedResources",
                requestData,
                "/api/library/instructor.php"
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.UpdateMultipleResourceData()
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult;
                    if (apiResult.status == "success") {
                        toast.success(this.stripHtml(apiResult.message), {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        this.setState({
                            updateResourceLoading: false
                        });
                        this.closeImportResourceModal()
                    } else {
                        toast.warn(this.stripHtml(apiResult.message), {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        this.setState({
                            updateResourceLoading: false
                        });
                    }
                } else {
                    toast.error('Something went wrong while updating resources data. Please try again later.', {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.setState({
                        updateResourceLoading: false
                    });
                }
            }

        }
        else if (this.props.modalTitle === "Update Resource Location" || this.props.modalTitle === "Update Resource Category" || this.props.modalTitle === "Update Resource Type" || this.props.modalTitle === "Update Invoice Number" || this.props.modalTitle === "Update Resource Status" || this.props.modalTitle === "Update Resource Language" || this.props.modalTitle === "Mark as donated") {
            let resourceObject = {
                "fieldsObj": { "fieldName": this.state.fieldNamePayload, "value": this.state.fieldValuePayload }, "selectedIdArray": this.props.SelectedResourcesIdArray
            }

            requestData = {
                iid: this.props.resourceSearchIID, // config.institute_id,
                resourceObject: resourceObject,
                facultyId: config.faculty_id,
                iidArray: this.props.iidArray
            }

            jsonResponse = await LibraryApiCall.makeApiCall(
                "updateLibraryResourceSelectedFiledofSelectedResource",
                requestData,
                "/api/library/instructor.php"
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.apiCallForUpdateResourceData()
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult;
                    if (apiResult.status == "success") {
                        toast.success(apiResult.message, {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        this.closeImportResourceModal()
                    } else {
                        toast.warn(apiResult.message, {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                } else {
                    toast.error('Something went wrong while updating resources data. Please try again later.', {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            }
        }
    }

    render() {
        const { updateMultipleAction, modalTitle } = this.props;
        // Multi select : Conditional logic based on 'keys'
        if (modalTitle === "Update Accession Series") {
            multipleSelectOption = this.props.accessionSeriesListData
        } else if (modalTitle === "Update Resource Location") {
            // custom location and sub-location data list
            locationSubLocationData = Object.values(this.props.locationListData).reduce((acc, location) => {
                const { value, name, sublocations } = location;

                if (sublocations && sublocations.length > 0) {
                    // Parent location (disabled)
                    acc.push({
                        value: value,
                        label: name.length > 25 ? name.slice(0, 25) + '...' : name,
                        isDisabled: true,
                    });

                    // Add each sublocation as selectable
                    const subOptions = sublocations.map(sub => {
                        const label = `${name} => ${sub.sublocationName}`;
                        return {
                            value: sub.sublocationId,
                            label: label.length > 25 ? label.slice(0, 25) + '...' : label,
                        };
                    });

                    acc.push(...subOptions);
                } else {
                    // Location with no sublocations (selectable)
                    acc.push({
                        value: value,
                        label: name.length > 25 ? name.slice(0, 25) + '...' : name,
                        isDisabled: false,
                    });
                }

                return acc;
            }, []);

            multipleSelectOption = locationSubLocationData;
        } else if (modalTitle === "Update Resource Category") {
            // custom category and sub-category data list
            categorySubCategoryData = Object.values(this.props.resourceCategoryData).flatMap(item => {
                // Start with the category itself
                const categoryOption = {
                    value: item.value,
                    label: item.name,
                    isDisabled: item.subCategories.length > 0, // Disable the category if it has subcategories
                };

                // If the category has subcategories, add those as well
                const subCategoryOptions = item.subCategories.map(subCategory => ({
                    value: subCategory.subCategoryId,
                    label: `${item.name} => ${subCategory.subCategoryName}`, // Parent category name followed by subcategory name
                    isDisabled: false, // Subcategory is always enabled
                }));

                // Return the category option followed by the subcategory options
                return [categoryOption, ...subCategoryOptions];
            });

            multipleSelectOption = categorySubCategoryData;
        } else if (modalTitle === "Update Resource Type") {
            multipleSelectOption = this.props.resourceTypeData.map(item => ({
                value: item,
                label: item
            }));
        } else if (modalTitle === "Update Invoice Number") {
            multipleSelectOption = this.props.invoiceData.map(item => ({
                value: item.value,
                label: item.billno + " | " + item.billdate + " | " + item.vendorName
            }));
        } else if (modalTitle === "Update Resource Status") {
            multipleSelectOption = Object.values(this.props.resourceStatusData).map(item => ({
                value: item.status,
                label: item.status ? item.status.charAt(0).toUpperCase() + item.status.slice(1) : '' // item.status
            }));
        } else if (modalTitle === "Update Resource Language") {
            multipleSelectOption = this.props.resourceLanguageData.map(item => ({
                value: item,
                label: item
            }));
        } else if (modalTitle === "Mark as donated") {
            multipleSelectOption = this.props.donorsListData
        }

        return (
            <div className={updateMultipleAction ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div class="modal-dialog modal-dialog-centered" style={{ maxWidth: '50VW' }}>
                    <div class="modal-content">
                        {/* modal header data */}
                        <div class="modal-header" style={{ padding: '15px' }}>
                            <h6 class="modal-title text-white" style={{ fontWeight: 500, color: "#000000" }}>{modalTitle}</h6>
                            <FontAwesomeIcon icon={['fas', 'times']} className="text-white" size="sm" onClick={() => this.closeImportResourceModal()} style={{ cursor: "pointer" }} />
                        </div>

                        {/* modal content */}
                        <div class="modal-body" style={{ maxHeight: "60vh", height: '75vh', overflowY: 'auto' }}>
                            <div className="row">
                                <div className="col-md-12 pl-0 pr-0">
                                    <div style={{ fontSize: '13px', marginBottom: '4px' }}>
                                        <b>Note:</b>
                                        <ol style={{ paddingLeft: '18px', marginTop: '4px' }}>
                                            {this.state.noteText
                                                .split('. ')
                                                .filter(x => x.trim() !== "")
                                                .map((line, index) => (
                                                    <li key={index}>{line.endsWith('.') ? line : line + '.'}</li>
                                                ))}
                                        </ol>
                                    </div>

                                    <div>
                                        {modalTitle == "Update Resource Details" ?
                                            <>
                                                <div className="col-md-12 mb-4">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <label style={{ fontSize: "14px" }}>Resource Language</label>
                                                            <Select
                                                                isMulti={false}
                                                                options={this.props.resourceLanguageData.map(item => ({
                                                                    value: item,
                                                                    label: item
                                                                }))}
                                                                onChange={(event) => {
                                                                    this.setState({
                                                                        updateLanguage: event || ''
                                                                    })
                                                                }}
                                                                isSearchable
                                                                isClearable
                                                                value={this.state.updateLanguage}
                                                                placeholder="Select Resource Language"
                                                                styles={{
                                                                    control: (base) => ({
                                                                        ...base,
                                                                        minHeight: 42, // Minimum height for the control area
                                                                        height: 'auto', // Allow control to grow dynamically,
                                                                        fontSize: "13px",
                                                                        fontWeight: 400,
                                                                    }),
                                                                    option: (base, state) => ({
                                                                        ...base,
                                                                        fontSize: "13px",
                                                                        fontWeight: 400,
                                                                        backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                        color: state.isSelected ? '#333' : '#555',
                                                                    }),
                                                                    menu: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                        // maxHeight: '200px', // Limit the height of the dropdown
                                                                        overflowY: 'auto', // Enable scrolling inside the dropdown if it exceeds maxHeight
                                                                        position: 'absolute', // Fix the position to avoid getting cut off
                                                                    }),
                                                                    menuPortal: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999, // Ensure the menu is above other modal content
                                                                    }),
                                                                    placeholder: (base) => ({
                                                                        ...base,
                                                                        fontSize: '14px',
                                                                        fontWeight: '400', // Use fontWeight for normal text

                                                                    }),
                                                                }}
                                                                menuPortalTarget={document.body}
                                                            />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label style={{ fontSize: "14px" }}>Publisher</label>
                                                            <Select
                                                                isMulti={true}
                                                                options={this.props.publisherData.map(item => ({
                                                                    value: item.value,
                                                                    label: item.name
                                                                }))}
                                                                onChange={(event) => {
                                                                    this.setState({
                                                                        updatePublisher: event || ""
                                                                    })
                                                                }}
                                                                isSearchable
                                                                isClearable
                                                                value={this.state.updatePublisher}
                                                                placeholder="Select Publisher"
                                                                styles={{
                                                                    control: (base) => ({
                                                                        ...base,
                                                                        minHeight: 42, // Minimum height for the control area
                                                                        height: 'auto', // Allow control to grow dynamically,
                                                                        fontSize: "13px",
                                                                        fontWeight: 400,
                                                                    }),
                                                                    option: (base, state) => ({
                                                                        ...base,
                                                                        fontSize: "13px",
                                                                        fontWeight: 400,
                                                                        backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                        color: state.isSelected ? '#333' : '#555',
                                                                    }),
                                                                    menu: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                        // maxHeight: '200px', // Limit the height of the dropdown
                                                                        overflowY: 'auto', // Enable scrolling inside the dropdown if it exceeds maxHeight
                                                                        position: 'absolute', // Fix the position to avoid getting cut off
                                                                    }),
                                                                    menuPortal: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999, // Ensure the menu is above other modal content
                                                                    }),
                                                                    placeholder: (base) => ({
                                                                        ...base,
                                                                        fontSize: '14px',
                                                                        fontWeight: '400', // Use fontWeight for normal text

                                                                    }),
                                                                }}
                                                                menuPortalTarget={document.body}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-4">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <label style={{ fontSize: "14px" }}>Resource Category</label>
                                                            <Select
                                                                isMulti={true}
                                                                options={Object.values(this.props.resourceCategoryData).flatMap(item => {
                                                                    // Start with the category itself
                                                                    const categoryOption = {
                                                                        value: item.value,
                                                                        label: item.name,
                                                                        isDisabled: item.subCategories.length > 0, // Disable the category if it has subcategories
                                                                    };

                                                                    // If the category has subcategories, add those as well
                                                                    const subCategoryOptions = item.subCategories.map(subCategory => ({
                                                                        value: subCategory.subCategoryId,
                                                                        label: `${item.name} => ${subCategory.subCategoryName}`, // Parent category name followed by subcategory name
                                                                        isDisabled: false, // Subcategory is always enabled
                                                                    }));

                                                                    // Return the category option followed by the subcategory options
                                                                    return [categoryOption, ...subCategoryOptions];
                                                                })}
                                                                onChange={(event) => {
                                                                    this.setState({
                                                                        updateCategory: event || ""
                                                                    })
                                                                }}
                                                                isSearchable
                                                                isClearable
                                                                value={this.state.updateCategory}
                                                                placeholder="Select Resource Category"
                                                                styles={{
                                                                    control: (base) => ({
                                                                        ...base,
                                                                        minHeight: 42, // Minimum height for the control area
                                                                        height: 'auto', // Allow control to grow dynamically,
                                                                        fontSize: "13px",
                                                                        fontWeight: 400,
                                                                    }),
                                                                    option: (base, state) => ({
                                                                        ...base,
                                                                        fontSize: "13px",
                                                                        fontWeight: 400,
                                                                        backgroundColor: state.isDisabled ? '#f0f0f0' : state.isFocused ? '#e0e0e0' : 'white',
                                                                        color: state.isDisabled ? '#999' : '#555',
                                                                        cursor: state.isDisabled ? 'not-allowed' : 'default',
                                                                    }),
                                                                    menu: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                        // maxHeight: '200px', // Limit the height of the dropdown
                                                                        overflowY: 'auto', // Enable scrolling inside the dropdown if it exceeds maxHeight
                                                                        position: 'absolute', // Fix the position to avoid getting cut off
                                                                    }),
                                                                    menuPortal: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999, // Ensure the menu is above other modal content
                                                                    }),
                                                                    placeholder: (base) => ({
                                                                        ...base,
                                                                        fontSize: '14px',
                                                                        fontWeight: '400', // Use fontWeight for normal text

                                                                    }),
                                                                }}
                                                                menuPortalTarget={document.body}
                                                            />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label style={{ fontSize: "14px" }}>Location</label>
                                                            <Select
                                                                // isMulti={true}
                                                                options={Object.values(this.props.locationListData).reduce((acc, location) => {
                                                                    const { value, name, sublocations } = location;

                                                                    if (sublocations && sublocations.length > 0) {
                                                                        // Parent location (disabled)
                                                                        acc.push({
                                                                            value: value,
                                                                            label: name.length > 25 ? name.slice(0, 25) + '...' : name,
                                                                            isDisabled: true,
                                                                        });

                                                                        // Add each sublocation as selectable
                                                                        const subOptions = sublocations.map(sub => {
                                                                            const label = `${name} => ${sub.sublocationName}`;
                                                                            return {
                                                                                value: sub.sublocationId,
                                                                                label: label.length > 25 ? label.slice(0, 25) + '...' : label,
                                                                            };
                                                                        });

                                                                        acc.push(...subOptions);
                                                                    } else {
                                                                        // Location with no sublocations (selectable)
                                                                        acc.push({
                                                                            value: value,
                                                                            label: name.length > 25 ? name.slice(0, 25) + '...' : name,
                                                                            isDisabled: false,
                                                                        });
                                                                    }

                                                                    return acc;
                                                                }, [])}
                                                                onChange={(event) => {
                                                                    this.setState({
                                                                        updateLocation: event || ''
                                                                    })
                                                                }}
                                                                isSearchable
                                                                isClearable
                                                                value={this.state.updateLocation}
                                                                placeholder="Select Location"
                                                                styles={{
                                                                    control: (base) => ({
                                                                        ...base,
                                                                        minHeight: 42, // Minimum height for the control area
                                                                        height: 'auto', // Allow control to grow dynamically,
                                                                        fontSize: "13px",
                                                                        fontWeight: 400,
                                                                    }),
                                                                    option: (base, state) => ({
                                                                        ...base,
                                                                        fontSize: "13px",
                                                                        fontWeight: 400,
                                                                        backgroundColor: state.isDisabled ? '#f0f0f0' : state.isFocused ? '#e0e0e0' : 'white',
                                                                        color: state.isDisabled ? '#999' : '#555',
                                                                        cursor: state.isDisabled ? 'not-allowed' : 'default',
                                                                    }),
                                                                    menu: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                        // maxHeight: '200px', // Limit the height of the dropdown
                                                                        overflowY: 'auto', // Enable scrolling inside the dropdown if it exceeds maxHeight
                                                                        position: 'absolute', // Fix the position to avoid getting cut off
                                                                    }),
                                                                    menuPortal: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999, // Ensure the menu is above other modal content
                                                                    }),
                                                                    placeholder: (base) => ({
                                                                        ...base,
                                                                        fontSize: '14px',
                                                                        fontWeight: '400', // Use fontWeight for normal text

                                                                    }),
                                                                }}
                                                                menuPortalTarget={document.body}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <label style={{ fontSize: "14px" }}>Department</label>
                                                            <Select
                                                                isMulti={true}
                                                                options={this.props.streamListData.map(item => ({
                                                                    value: item.sid,
                                                                    label: item.name
                                                                }))}
                                                                onChange={(event) => {
                                                                    this.setState({
                                                                        updateDepartment: event || []
                                                                    })
                                                                }}
                                                                isSearchable
                                                                isClearable
                                                                value={this.state.updateDepartment}
                                                                placeholder="Select Department"
                                                                styles={{
                                                                    control: (base) => ({
                                                                        ...base,
                                                                        minHeight: 42, // Minimum height for the control area
                                                                        height: 'auto', // Allow control to grow dynamically,
                                                                        fontSize: "13px",
                                                                        fontWeight: 400,
                                                                    }),
                                                                    option: (base, state) => ({
                                                                        ...base,
                                                                        fontSize: "13px",
                                                                        fontWeight: 400,
                                                                        backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                        color: state.isSelected ? '#333' : '#555',
                                                                    }),
                                                                    menu: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                        // maxHeight: '200px', // Limit the height of the dropdown
                                                                        overflowY: 'auto', // Enable scrolling inside the dropdown if it exceeds maxHeight
                                                                        position: 'absolute', // Fix the position to avoid getting cut off
                                                                    }),
                                                                    menuPortal: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999, // Ensure the menu is above other modal content
                                                                    }),
                                                                    placeholder: (base) => ({
                                                                        ...base,
                                                                        fontSize: '14px',
                                                                        fontWeight: '400', // Use fontWeight for normal text

                                                                    }),
                                                                }}
                                                                menuPortalTarget={document.body}
                                                            />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label style={{ fontSize: "14px" }}>Resource Type</label>
                                                            <Select
                                                                isMulti={false}
                                                                options={this.props.resourceTypeData.map(item => ({
                                                                    value: item,
                                                                    label: item
                                                                }))}
                                                                onChange={(event) => {
                                                                    this.setState({
                                                                        updateResourceType: event || ''
                                                                    })
                                                                }}
                                                                isSearchable
                                                                isClearable
                                                                value={this.state.updateResourceType}
                                                                placeholder="Select Resource Language"
                                                                styles={{
                                                                    control: (base) => ({
                                                                        ...base,
                                                                        minHeight: 42, // Minimum height for the control area
                                                                        height: 'auto', // Allow control to grow dynamically,
                                                                        fontSize: "13px",
                                                                        fontWeight: 400,
                                                                    }),
                                                                    option: (base, state) => ({
                                                                        ...base,
                                                                        fontSize: "13px",
                                                                        fontWeight: 400,
                                                                        backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                        color: state.isSelected ? '#333' : '#555',
                                                                    }),
                                                                    menu: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                        // maxHeight: '200px', // Limit the height of the dropdown
                                                                        overflowY: 'auto', // Enable scrolling inside the dropdown if it exceeds maxHeight
                                                                        position: 'absolute', // Fix the position to avoid getting cut off
                                                                    }),
                                                                    menuPortal: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999, // Ensure the menu is above other modal content
                                                                    }),
                                                                    placeholder: (base) => ({
                                                                        ...base,
                                                                        fontSize: '14px',
                                                                        fontWeight: '400', // Use fontWeight for normal text

                                                                    }),
                                                                }}
                                                                menuPortalTarget={document.body}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            <>
                                                <label className="vm_custom_body5" style={{ color: '#454E52', display: 'block' }} htmlFor="SeriesAdvFilter">
                                                    {modalTitle}
                                                </label>
                                                <Select
                                                    isMulti={this.state.isMultiSelect}
                                                    options={multipleSelectOption}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            selectedValue: event || []
                                                        })
                                                    }}
                                                    isSearchable
                                                    isClearable
                                                    value={this.state.selectedValue}
                                                    placeholder={`Select ${this.state.fieldPlaceholder}`}
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            minHeight: 42, // Minimum height for the control area
                                                            height: 'auto', // Allow control to grow dynamically,
                                                            fontSize: "13px",
                                                            fontWeight: 400,
                                                        }),
                                                        option: (base, state) => ({
                                                            ...base,
                                                            fontSize: "13px",
                                                            fontWeight: 400,
                                                            backgroundColor: state.isDisabled ? '#f0f0f0' : state.isFocused ? '#e0e0e0' : 'white',
                                                            color: state.isDisabled ? '#999' : '#555',
                                                            cursor: state.isDisabled ? 'not-allowed' : 'default',
                                                        }),
                                                        menu: (base) => ({
                                                            ...base,
                                                            zIndex: 9999, // Ensure the dropdown appears above other elements
                                                            // maxHeight: '200px', // Limit the height of the dropdown
                                                            overflowY: 'auto', // Enable scrolling inside the dropdown if it exceeds maxHeight
                                                            position: 'absolute', // Fix the position to avoid getting cut off
                                                        }),
                                                        menuPortal: (base) => ({
                                                            ...base,
                                                            zIndex: 9999, // Ensure the menu is above other modal content
                                                        }),
                                                        placeholder: (base) => ({
                                                            ...base,
                                                            fontSize: '14px',
                                                            fontWeight: '400', // Use fontWeight for normal text

                                                        }),
                                                    }}
                                                    menuPortalTarget={document.body}
                                                />
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Modal footer button */}
                        <div className="modal-footer" style={{ padding: '20px 25px' }}>
                            {this.state.updateResourceLoading ? <ButtonLoader /> : null}
                            {/* borderColor: '#0465AC !important' */}
                            <button className="btn custom-btn" style={{ fontSize: '14px', borderRadius: '7px' }} onClick={() => this.closeImportResourceModal()}><span className='fs-13'>Cancel</span></button>
                            {
                                // backgroundColor: this.state.selectedDonorName.length == 0 ? '#616161' : '#0465AC', cursor: this.state.selectedDonorName.length == 0 ? 'not-allowed' : 'pointer' 
                                <button className="btn"
                                    style={{ fontSize: '14px', borderRadius: '7px', color: '#fff', backgroundColor: '#0465AC', cursor: 'pointer' }} onClick={() => this.UpdateMultipleResourceData()} disabled={this.state.updateResourceLoading}>{modalTitle}</button>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default UpdateMultipleAction;